module.exports = __webpack_public_path__ + "img/成果展示 高校院所.4241084d.png";